export const getIntervalUnitAndValue = (interval, intervalUnits) => {
    const intervalInSeconds = interval || 0
    const intervalUnitsValues = Object.values(intervalUnits)

    for (let i = intervalUnitsValues.length - 1; i >= 0; i--) {
        const unitInfo = intervalUnitsValues[i]

        if (intervalInSeconds % unitInfo.interval === 0) {
            return {
                unitLabel: unitInfo.label,
                unitValue: intervalInSeconds / unitInfo.interval,
                unit: unitInfo.value
            }
        }
    }

    return {
        unitLabel: intervalUnits.second.label,
        unitValue: intervalInSeconds,
        unit: intervalUnits.second.value
    }
}
